import React from 'react';
import {
  Hammer, Scissors, Ruler, GitBranchPlus, ScrollText, Package,
} from 'lucide-react';
import GenericSectionDashboard from '../GenericSectionDashboard';

const ShirtManufacturingDashboard = () => {
  // Custom priority tiles specific to Shirt Manufacturing ops
  const customTiles = [
    {
      id: 'shirt-mfg-hub',
      title: 'Job-Work Hub',
      description: 'JW Orders, BOM Master, USN Bank',
      icon: Hammer,
      iconBg: 'bg-purple-600',
      route: '/sections/shirt-manufacturing/hub',
      testId: 'shirt-mfg-hub-tile',
      priority: true,
    },
    {
      id: 'shirt-mfg-bundle-split',
      title: 'Bundle Split',
      description: 'Split a received shirting bundle (scraps original)',
      icon: GitBranchPlus,
      iconBg: 'bg-amber-600',
      route: '/sections/shirt-manufacturing/bundle-split',
      testId: 'shirt-mfg-bundle-split-tile',
      priority: true,
    },
    {
      id: 'shirt-mfg-qty-inspection',
      title: 'Qty Inspection',
      description: 'Record actual qty per bundle',
      icon: Ruler,
      iconBg: 'bg-sky-600',
      route: '/sections/shirt-manufacturing/qty-inspection',
      testId: 'shirt-mfg-qty-inspection-tile',
      priority: true,
    },
    {
      id: 'shirt-mfg-variance-report',
      title: 'Variance Report',
      description: 'Bundle & consignment-level variance',
      icon: ScrollText,
      iconBg: 'bg-rose-600',
      route: '/sections/shirt-manufacturing/variance-report',
      testId: 'shirt-mfg-variance-report-tile',
      priority: true,
    },
    {
      id: 'shirt-mfg-assortment',
      title: 'Shirts Assortment',
      description: 'Pack replace-USNs into boxes, transfer to SFG',
      icon: Package,
      iconBg: 'bg-emerald-600',
      route: '/sections/shirt-manufacturing/shirts-assortment',
      testId: 'shirt-mfg-assortment-tile',
      priority: true,
    },
  ];

  return (
    <GenericSectionDashboard
      sectionName="Shirt Manufacturing"
      sectionId="shirt-manufacturing"
      sectionKey="Shirt Manufacturing"
      description="Shirting fabric → JW → Shirts, inspection & dispatch"
      customTiles={customTiles}
    />
  );
};

export default ShirtManufacturingDashboard;
